import { Icon } from '@iconify/react';
import { isBlocked } from '../visitorConstants';

// Per-row controls, shared by the table and the card grid. Block and unblock
// are mutually exclusive — a visitor is only ever in one of the two states —
// so one slot swaps between them rather than showing both greyed out.
const VisitorRowActions = ({
    visitor,
    canUpdate,
    canDelete,
    busy = false,
    onView,
    onEdit,
    onBlock,
    onUnblock,
    onDelete,
}) => {
    const blocked = isBlocked(visitor);

    return (
        <div className="tw-inline-flex tw-items-center tw-gap-1">
            <button
                title="View profile"
                onClick={() => onView(visitor)}
                className="tw-p-1.5 tw-rounded hover:tw-bg-blue-50 tw-text-blue-600"
            >
                <Icon icon="mdi:eye-outline" className="tw-text-base" />
            </button>

            {canUpdate && (
                <button
                    title="Edit"
                    onClick={() => onEdit(visitor)}
                    className="tw-p-1.5 tw-rounded hover:tw-bg-amber-50 tw-text-amber-600"
                >
                    <Icon icon="mdi:pencil-outline" className="tw-text-base" />
                </button>
            )}

            {canUpdate && (blocked ? (
                <button
                    title="Unblock"
                    disabled={busy}
                    onClick={() => onUnblock(visitor)}
                    className="tw-p-1.5 tw-rounded hover:tw-bg-emerald-50 tw-text-emerald-600 disabled:tw-opacity-50"
                >
                    <Icon icon="mdi:lock-open-variant-outline" className="tw-text-base" />
                </button>
            ) : (
                <button
                    title="Block at gate"
                    disabled={busy}
                    onClick={() => onBlock(visitor)}
                    className="tw-p-1.5 tw-rounded hover:tw-bg-orange-50 tw-text-orange-600 disabled:tw-opacity-50"
                >
                    <Icon icon="mdi:block-helper" className="tw-text-base" />
                </button>
            ))}

            {canDelete && (
                <button
                    title="Remove"
                    onClick={() => onDelete(visitor)}
                    className="tw-p-1.5 tw-rounded hover:tw-bg-rose-50 tw-text-rose-600"
                >
                    <Icon icon="mdi:trash-can-outline" className="tw-text-base" />
                </button>
            )}
        </div>
    );
};

export default VisitorRowActions;
